/* ───────────────────────────────────────────────────────────────
   Fairylicense product-card image swipe.

   Mobile/touch progressive enhancement: turns a card's front/back .card__photo
   pair into a horizontal scroll-snap track + dot band. Desktop keeps the native
   front/back hover cross-fade in fl-product-card.css. Cards with <2 images are
   left as-is, so the static front image and overlay link keep working with no JS.

   Loaded globally (layout/theme.liquid) so every card surface gets it: home
   "Just landed", PLPs, wishlist, and the PDP "You might also like" row.
   ─────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CAN_SWIPE_ENHANCE = !window.matchMedia || window.matchMedia('(hover: none), (pointer: coarse), (max-width: 768px)').matches;

  function enhance(wrap) {
    if (wrap.classList.contains('is-swipe')) return;
    var photos = wrap.querySelectorAll('.card__photo');
    if (photos.length < 2) return; // single image → nothing to swipe

    var card = wrap.closest('.card');
    var nameEl = card && card.querySelector('.card__name');
    var cardName = nameEl ? nameEl.textContent.trim() : '';
    var n = photos.length;

    // Build the scroll-snap track from the existing pictures. Re-classing
    // .card__photo → .card__slide makes the hover cross-fade CSS inert.
    var track = document.createElement('div');
    track.className = 'card__swipe';
    Array.prototype.forEach.call(photos, function (pic, i) {
      pic.classList.remove('card__photo', 'card__photo--front', 'card__photo--back');
      pic.classList.add('card__slide');
      pic.removeAttribute('aria-hidden');
      var im = pic.querySelector('img');
      if (im && !im.getAttribute('alt') && cardName) im.setAttribute('alt', cardName + ' — view ' + (i + 1));
      track.appendChild(pic);
    });
    wrap.insertBefore(track, wrap.firstChild);

    // Keep the overlay link for keyboard/semantics, but stop it blocking the swipe.
    var link = wrap.querySelector('.card__link');
    if (link) link.style.pointerEvents = 'none';

    // Dot band — sibling overlay (not inside the scroller), plain buttons.
    var dots = document.createElement('div');
    dots.className = 'card__dots';
    var dotBtns = [];
    for (var i = 0; i < n; i++) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'card__dot-btn' + (i === 0 ? ' is-active' : '');
      d.setAttribute('aria-label', 'View image ' + (i + 1) + ' of ' + n);
      d.dataset.idx = i;
      dots.appendChild(d);
      dotBtns.push(d);
    }
    wrap.appendChild(dots);
    wrap.classList.add('is-swipe');

    function clampIdx(x) { return Math.max(0, Math.min(n - 1, x)); }
    function goTo(idx, smooth) {
      track.scrollTo({ left: clampIdx(idx) * track.clientWidth, behavior: (smooth && !REDUCE.matches) ? 'smooth' : 'auto' });
    }

    // Active dot follows scroll (rAF-throttled, passive).
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var idx = clampIdx(Math.round(track.scrollLeft / track.clientWidth));
        dotBtns.forEach(function (b, j) { b.classList.toggle('is-active', j === idx); });
        ticking = false;
      });
    }, { passive: true });

    // Dot click → jump to slide.
    dots.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      goTo(parseInt(b.dataset.idx, 10) || 0, true);
    });

    // Mouse drag support for hybrid touch devices; touch/trackpad use native scroll-snap.
    var dragging = false, startX = 0, startScroll = 0, moved = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      dragging = true; moved = 0; startX = e.clientX; startScroll = track.scrollLeft;
      track.style.scrollSnapType = 'none'; // writing scrollLeft fights mandatory snap
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      track.scrollLeft = startScroll - dx;
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      track.style.scrollSnapType = '';
      goTo(Math.round(track.scrollLeft / track.clientWidth), true);
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // Tap (no drag) → the product page, mirroring the old full-image link.
    track.addEventListener('click', function () {
      if (moved > 8) { moved = 0; return; } // that was a drag, not a tap
      var go = wrap.querySelector('.card__link') || (card && card.querySelector('a[href]'));
      var href = go && go.getAttribute('href');
      if (href) window.location.href = href;
    });
  }

  function init() {
    if (!CAN_SWIPE_ENHANCE) return;

    var wraps = document.querySelectorAll('.card__image:not(.is-swipe)');
    Array.prototype.forEach.call(wraps, enhance);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
